import * as React from "react";
import cx from "classnames";

import styles from "./block.module.css";

interface IProps {
  children: React.ReactChild | React.ReactChild[];
  isWide?: boolean;
  hasError?: boolean;
}

export default function Block({ children, isWide, hasError }: IProps) {
  return (
    <div
      className={cx(styles.blockInput, {
        [styles.inputWide]: isWide,
        [styles.error]: hasError
      })}
    >
      {children}
    </div>
  );
}
